import { render, staticRenderFns } from "./AreaComponents.vue?vue&type=template&id=5b9e9e12&scoped=true&"
import script from "./AreaComponents.vue?vue&type=script&lang=js&"
export * from "./AreaComponents.vue?vue&type=script&lang=js&"
import style0 from "./AreaComponents.vue?vue&type=style&index=0&id=5b9e9e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e9e12",
  null
  
)

export default component.exports